import { Button, Col, Row } from "react-bootstrap";
import { BarChartLineFill, ClockHistory } from "react-bootstrap-icons";
import moment from "moment/min/moment-with-locales";
import { Suspense } from "react";
import { Await, useRouteLoaderData } from "react-router-dom";

export default function SongCatalogueRow({ item, setShowHistory, setShowTrend, trendDisabled, setSelectedTrendDataType, setSelectedRadioId }) {
    const { competitorRadios } = useRouteLoaderData("root");

    function handleSetTrendSong(e) {
        e.stopPropagation();
        setSelectedTrendDataType();
        setSelectedRadioId();
        setShowTrend(true);
    }

    function handleSetHistorySong() {
        setSelectedRadioId();
        setShowHistory(true);
    }

    return (
        <Row className={`py-1 border-bottom align-items-center hoverable fs-8-xs`} onClick={handleSetHistorySong}>
            <Col xs xl className=" align-content-center">
                <Suspense>
                    <Await resolve={competitorRadios}>
                        {resolvedRadios => (
                            <span className=" fs-7-xs fw-bold fw-xl-normal">{resolvedRadios.data.find(x => x.radio_id === item.radio_id)?.radio_name} </span>
                        )}
                    </Await>
                </Suspense>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={1} className="align-content-center text-center">
                <span className=" d-xl-none">This Week: </span>
                <span className=" fw-bold fw-xl-normal">{item.weeks[3].spins}</span>
            </Col>
            <Col xs={"auto"} xl={1} className="align-content-center text-center">
                <span className=" d-xl-none">Week -1: </span>
                <span className=" fw-bold fw-xl-normal">{item.weeks[2].spins}</span>
            </Col>
            <Col xs={"auto"} xl={1} className="align-content-center text-center">
                <span className=" d-xl-none">Week -2: </span>
                <span className=" fw-bold fw-xl-normal">{item.weeks[1].spins}</span>
            </Col>
            <Col xs={"auto"} xl={1} className="align-content-center text-center">
                <span className=" d-xl-none">Week -3: </span>
                <span className=" fw-bold fw-xl-normal">{item.weeks[0].spins}</span>
            </Col>
            <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                <span className=" d-xl-none">Total Spins: </span>
                <span className=" fw-bold fw-xl-normal">{item.total_spins}</span>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={2} className="align-content-center text-center">
                <span className=" d-xl-none">First Played: </span>
                <span className=" fw-bold fw-xl-normal">{moment(item.first_time).format("L HH:mm")}</span>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={1} className=" align-content-center px-xl-0">
                <Button variant="ra-yellow" className="py-0 py-xl-1 d-flex align-items-center column-gap-1 mx-auto" size="sm">
                    <ClockHistory height={16} width={16} /> History
                </Button>
            </Col>
            <Col xs={"auto"} xl={1} className=" align-content-center px-xl-0">
                <Button
                    variant="ra-yellow"
                    className="py-0 py-xl-1 d-flex align-items-center column-gap-1 mx-auto"
                    size="sm"
                    onClick={handleSetTrendSong}
                    disabled={trendDisabled}>
                    <BarChartLineFill height={16} width={16} /> Trend
                </Button>
            </Col>
        </Row>
    );
}
